@if (teamData) {
  <div class="mc-team-nav-link" [ngClass]="{'mc-team-nav-link_active': isTeamPage}">
    <a
      role="button"
      (click)="manageTeam($event)"
      (keydown.enter)="manageTeam($event)"
      (keydown.space)="manageTeam($event)"
      class="mc-team-nav-link__nav"
      [attr.tabindex]="isSidenavOpened ? '0' : '-1'"
    >
      <div class="mc-team-nav-link-img-wrapper">
        @if (teamData.teamMembers.teamImageUrl) {
          <img [src]="teamData.teamMembers.teamImageUrl" alt="{{ teamData.name }} logo" />
        } @else {
          <div class="mc-team-nav-link-img-wrapper__short-team-name">{{ teamShortName }}</div>
        }
      </div>
      <div class="mc-team-nav-link__text">
        <div class="mc-team-nav-link__team-data">
          <p class="mc-team-nav-link__team-name">{{ teamData.name }}</p>
          @if (teamData.teamMembersCount) {
            <p class="mc-team-nav-link__member-count">
              {{ teamData.teamMembersCount > 1 ? teamData.teamMembersCount + ' team members' : ' 1 team member' }}
            </p>
          } @else {
            <p>No team members</p>
          }
        </div>
      </div>
    </a>
    @if (loading) {
      <mc-progress-spinner />
    } @else if (hasMenu) {
      <button
        #menuButton
        type="button"
        class="mc-team-nav-link__menu-btn"
        (keydown.enter)="onToggleMenu($event)"
        (keydown.space)="onToggleMenu($event)"
        (keydown.arrowdown)="onMoveFocusIntoMenu($event)"
        (keydown.arrowright)="onMoveFocusIntoMenu($event)"
        (keydown.escape)="onCloseMenu($event)"
        [attr.tabindex]="isSidenavOpened ? '0' : '-1'"
        [attr.aria-expanded]="menuOpen"
        aria-haspopup="menu"
        [attr.aria-label]="'Switch account, current account ' + teamData.name"
      >
        <mat-icon class="mc-team-nav-link__icon" svgIcon="triangle_right" aria-hidden="true"></mat-icon>
      </button>
    } @else {
      <mat-icon
        class="mc-team-nav-link__icon mc-team-nav-link__icon_static"
        svgIcon="triangle_right"
        aria-hidden="true"
      ></mat-icon>
    }
  </div>
}
